import { useBrand, brandUrl } from "@/hooks/useBrand";

function FallbackSvg({ size, className }) {
  const id = `sidi-${size}`;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} data-testid="sidi-logo" aria-label="SIDI Paris">
      <defs>
        <radialGradient id={`${id}-leather`} cx="40%" cy="35%" r="75%">
          <stop offset="0%" stopColor="#2a2220" /><stop offset="60%" stopColor="#120f0d" /><stop offset="100%" stopColor="#050505" />
        </radialGradient>
        <linearGradient id={`${id}-gold`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#D9C7A0" /><stop offset="50%" stopColor="#B89F78" /><stop offset="100%" stopColor="#7E6A48" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="14" fill={`url(#${id}-leather)`} />
      <path d="M62 18 C50 22, 40 30, 36 44 L64 44 C68 34, 66 24, 62 18 Z" fill={`url(#${id}-gold)`} />
      <path d="M38 82 C50 78, 60 70, 64 56 L36 56 C32 66, 34 76, 38 82 Z" fill={`url(#${id}-gold)`} />
    </svg>
  );
}

/** Monogramme carré (header, favicon, petites tailles). */
export default function SidiLogo({ size = 44, className = "" }) {
  const brand = useBrand();
  const src = brandUrl("mark", brand) || brandUrl("logo", brand);
  if (!src) return <FallbackSvg size={size} className={className} />;
  return <img src={src} alt="SIDI Paris" width={size} height={size} className={`object-cover rounded-full ${className}`} style={{ width: size, height: size }} data-testid="sidi-logo" />;
}

/** Logo complet « Sidi Paris » sur cuir (login, portail, écrans d'accueil). */
export function SidiWordmark({ height = 160, className = "" }) {
  const brand = useBrand();
  const src = brandUrl("wordmark", brand) || brandUrl("logo", brand);
  if (!src) return <FallbackSvg size={height} className={className} />;
  return <img src={src} alt="Sidi Paris" className={`object-contain rounded-2xl ${className}`} style={{ height }} data-testid="sidi-wordmark" />;
}
